import { connect } from 'react-redux';
import
{
  setMetricsByDateInfo,
  setExportPerformanceInfo,
  setCaseAmendingPerformanceInfo,
  setCaseAmendingKppPerformanceInfo,
  setJobBenchmarkMetricsInfo
} from './../actions';
import RegressionTestsPerformanceSelectorComponent
  from './../Components/RegressionTestsPerformanceSelectorComponent';

import {
  getJobById,
  paramsByJobIds,
  getMetricsByDateInfo,
  getMetricsPageInfo,
  getMetricsDispatcherType,
  getDispatchersByTypesAfterCaseMetricsDate,
  getRegressionScenarioNames,
  getScenarioNamesPartI,
  getScenarioNamesPartIIByPartI,
  getScenarioNamesPartIIIByPartINII,
} from './../reducers';

import {
  pageTypes,
  params as paramsConstant,
  jobNames,
  dispatcherTypes
} from './../helpers';


export const mapStateToProps = (state, ownProps) => {
  const dispatcherType = getMetricsDispatcherType(state);

  let dispatchers =
    getDispatchersByTypesAfterCaseMetricsDate(state, dispatcherType);
  const metricsInfo = getMetricsPageInfo(state);
  if (dispatcherType === dispatcherTypes.CASEAMENDINGTESTS) {
    if (metricsInfo.jobName === jobNames.CASE_AMENDING) {
      dispatchers = dispatchers && dispatchers.filter(d => {
        const job = getJobById(state, d.job_id);
        return job && job.name === jobNames.CASE_AMENDING_DISPATCHER;
      });
    }
    else {
      dispatchers = dispatchers && dispatchers.filter(d => {
        const job = getJobById(state, d.job_id);
        return job && job.name === jobNames.CASE_AMENDING_KPP_DISPATCHER;
      });
    }
  }
  const dispatchersJobNums = dispatchers ?
    dispatchers.map(d => {
      const param = paramsByJobIds(state)[d.job_id];
      const job = getJobById(state, d.job_id);
      let name = '';
      if (param)
        name = param[paramsConstant.JENKINS_TRIGGER_BY] ||
         param[paramsConstant.DISPATCHEDBY] || '';
      return {
        id: d.id,
        number: job ? job.number : 0,
        jobId: d.job_id,
        name: name.replace('_', '-'),
        scenarioCount: d.scenario_count
      };
    }) :
    [];

  return {
    metricsByDateInfo: getMetricsByDateInfo(state),
    metricsInfo,
    availableSNsPartI: getScenarioNamesPartI(state),
    availableSNsPartIIByPartI: ownProps.pageType === pageTypes.CASEAMENDINGKPPTESTS ?
      getRegressionScenarioNames(state) :
      getScenarioNamesPartIIByPartI(state),
    availableSNsPartIIIByPartINII: getScenarioNamesPartIIIByPartINII(state),
    availableDispatchers: dispatchersJobNums
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
  onSelectorChange: (info) => {
    dispatch(setMetricsByDateInfo(info));

    switch (ownProps.pageType) {
      case pageTypes.EXPORTTESTS:
        if (info.dispatcherId || (info.snPartI && info.snPartII && info.snPartIII)) {
          dispatch(setExportPerformanceInfo(info));
        }
        break;
      case pageTypes.CASEAMENDINGTESTS:
        if (info.dispatcherId || info.snPartI && info.snPartII) {
          dispatch(setCaseAmendingPerformanceInfo(info));
        }
        break;
      case pageTypes.CASEAMENDINGKPPTESTS:
        if (info.dispatcherId || info.snPartII) {
          dispatch(setCaseAmendingKppPerformanceInfo(info));
        }
        break;
      case pageTypes.JOBBENCHMARK:
        if (info.dispatcherId || info.snPartII) {
          dispatch(setJobBenchmarkMetricsInfo(info));
        }
        break;
      default:
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegressionTestsPerformanceSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/RegressionTestsPerformanceSelectorContainer.jsx